module.exports = __webpack_public_path__ + "img/returnToAdmin-icon-gray.1c4404df.svg";